// WebSocket transport. Один binary WS-канал ко всему: Hello, Snapshot, Input,
// EventBatch, Chat. Сервер за Caddy, который проксирует /api/ws с автоматическим
// HTTP→WS upgrade.
//
// Почему WebSocket: WebRTC давал ICE roulette + pion TCP-mux баги (SCTP-buffer
// рос без дренажа). WebSocket работает всегда (HTTP/443), latency для
// client-server игры приемлемая (50-80ms TCP roundtrip).

export interface TransportHandlers {
  /** Любое полученное от сервера сообщение (binary frame). */
  onMessage: (data: Uint8Array) => void;
  onOpen: () => void;
  onClose: (reason: string) => void;
}

export class WebSocketTransport {
  private ws: WebSocket | null = null;
  private opened = false;

  constructor(private wsUrl: string, private handlers: TransportHandlers) {}

  async connect(nickname: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const sep = this.wsUrl.includes("?") ? "&" : "?";
      const url = `${this.wsUrl}${sep}nick=${encodeURIComponent(nickname)}`;
      const ws = new WebSocket(url);
      ws.binaryType = "arraybuffer";
      this.ws = ws;
      ws.onopen = () => {
        this.opened = true;
        this.handlers.onOpen();
        resolve();
      };
      ws.onerror = (ev) => {
        if (!this.opened) reject(new Error(`WebSocket connect failed: ${String(ev)}`));
      };
      ws.onclose = (ev) => {
        this.opened = false;
        this.handlers.onClose(`code=${ev.code} reason=${ev.reason || "(none)"}`);
      };
      ws.onmessage = (ev) => {
        if (ev.data instanceof ArrayBuffer) {
          this.handlers.onMessage(new Uint8Array(ev.data));
        }
      };
      // Защита от ICE/network issue при первом подключении.
      setTimeout(() => {
        if (!this.opened) reject(new Error("WebSocket connect timeout"));
      }, 8000);
    });
  }

  send(data: Uint8Array): void {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    this.ws.send(data);
  }

  close(): void {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  isOpen(): boolean {
    return this.ws?.readyState === WebSocket.OPEN;
  }
}
